import { useEffect, useState } from 'react';
import { isMobile, getConcentrationLevel } from '../Utilities/Helpers';

import '../Styles/HoverTooltip.css';

export default function HoverTooltip(props) {
	const { data, mousePosition, hoverTooltipVisible, setHoverTooltipVisible, language } = props;

	const [tooltipDefaultRightPos, setTooltipDefaultRightPos] = useState(true);
	const [tooltipDefaultBottomPos, setTooltipDefaultBottomPos] = useState(true);

	const hoverMaxWidth = 340;
	const hoverMaxHeight = 240;
	const hoverBuffer = 20;
	const rightHoverBuffer = 60;
	const bottomHoverBuffer = 60;

	// tooltip visibility
	useEffect(() => {
		setHoverTooltipVisible(!isMobile() && !!data?.content);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);


	// track mouse movement and free space on the right hand side of the tooltip & bottom of the tooltip
	useEffect(() => {
		const leftPosition = mousePosition.left + hoverMaxWidth;
		const moveTooltipLeft = isMobile() ? false : (window.innerWidth - leftPosition < hoverBuffer);
		setTooltipDefaultRightPos(!moveTooltipLeft);

		const topPosition = mousePosition.top + hoverMaxHeight;
		const moveTooltipTop = isMobile() ? false : (window.innerHeight - topPosition < hoverBuffer);
		setTooltipDefaultBottomPos(!moveTooltipTop);
	}, [mousePosition]);


	const generateContent = () => {
		const concentrationValueRaw = parseFloat(data?.content?.['Nitrat']) || 0;
		const concentrationValue = Math.floor(concentrationValueRaw*100)/100;
		const concentrationLevel = getConcentrationLevel(concentrationValue);
		const levelId = concentrationLevel.id;

		return (
			<>
				<div
					className={`hover-tooltip-wrapper ${hoverTooltipVisible ? 'show' : ''}`}
					style={hoverTooltipVisible && {
						left: tooltipDefaultRightPos ? mousePosition.left : (mousePosition.left - hoverMaxWidth + rightHoverBuffer),
						top: tooltipDefaultBottomPos ? mousePosition.top : (mousePosition.top - hoverMaxHeight + bottomHoverBuffer)
					}}
				>
					<div className='hover-main-wrapper'>
						<div className="data-wrapper">
							<div className="hover-tooltip-title">{language ? language['hovertooltip:header'] : 'Nitrate level'}</div>
							<div className="hover-tooltip-counter">
								<div className={'value'}>{concentrationValue}</div>
								<div className="units">{language ? language['hovertooltip:concentration'] : 'mg/L'}</div>
							</div>
							<div className="hover-tooltip-counter-desc">{language ? language[`popup:concentration_level:${levelId}:description`] : concentrationLevel.description}</div>
						</div>

						{concentrationLevel &&
							<div className="icons-wrapper">
								{concentrationLevel.healthIcons && concentrationLevel.healthIcons.map((icon, index) => {
									return (<div key={index} className='icons-column'>
										<div className={`tooltip-icon ${icon}`}></div>
										<div className='tooltip-icon-text'>{language ? language[`hovertooltip:icons:${icon}`] : ''}</div>
									</div>);
								})}
							</div>
						}
						<div className='hover-readmore'>{language ? language[`hovertooltip:read_more`] : 'Click to read more'}</div>
					</div>
				</div>
			</>
		);
	}

	return (
		<>
			{hoverTooltipVisible && data.content && generateContent()}
		</>
	);

};
